import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const deleteModalUsersSlice = createSlice({
  name: "deleteModalUsers",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalUsersSlice.actions;
export default deleteModalUsersSlice.reducer;
